import { render, staticRenderFns } from "./UrunSecilenKurToplam.vue?vue&type=template&id=286a008e&scoped=true"
import script from "./UrunSecilenKurToplam.vue?vue&type=script&lang=js"
export * from "./UrunSecilenKurToplam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286a008e",
  null
  
)

export default component.exports